import React from 'react';
import Link from '@material-ui/core/Link';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import { FAQParent } from './animation/variants';

import QuestionDropdown from './QuestionDropdown';

import {
  question1,
  question2,
  question3,
  question4,
  question5,
  question6,
  question7,
  question8,
  question9,
  question10,
} from './questions';
import {
  answer1,
  answer2,
  answer3,
  answer4,
  answer5,
  answer6,
  answer7,
  answer8,
  answer9,
} from './answers';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: '30px',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '50px',
    },
  },
  title: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
  },
  subtitle: {
    marginTop: '25px',
    color: theme.palette.secondary.light,
    fontSize: '28px',
    fontWeight: 'bold',
    lineHeight: '35px',
    textAlign: 'center',
    letterSpacing: '-0.03em',
  },
  description: {
    maxWidth: '950px',
    fontSize: 24,
    fontWeight: 'normal',
    lineHeight: '31px',
    textAlign: 'center',
    letterSpacing: '-0.03em',
    paddingBottom: '50px',
  },
  questionsRoot: {
    display: 'flex',
    flexDirection: 'row',
  },
  questionsWrapper: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column !important',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '1440px',
    },
  },
}));

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const QuestionColumnWrapper = styled.div`
  margin: 0 10px;
  & > * {
    margin-bottom: 40px;
  }
`;

const FAQ = () => {
  const [ref, inView] = useInView({
    rootMargin: '-200px 100px',
    triggerOnce: true,
  });

  const classes = useStyles();
  return (
    <motion.div
      className={classes.root}
      ref={ref}
      variants={FAQParent}
      initial="initial"
      animate={inView ? 'enter' : 'initial'}>
      <Typography variant="h2" className={classes.title} id="faq">
        Frequently Asked Questions
      </Typography>
      <div className={classes.questionsRoot}>
        <QuestionWrapper className={classes.questionsWrapper}>
          <QuestionColumnWrapper>
            <QuestionDropdown question={question1} answer={answer1} />
            <QuestionDropdown question={question3} answer={answer3} />
            <QuestionDropdown question={question5} answer={answer5} />
            <QuestionDropdown question={question7} answer={answer7} />
            <QuestionDropdown question={question9} answer={answer9} />
          </QuestionColumnWrapper>
          <QuestionColumnWrapper>
            <QuestionDropdown question={question2} answer={answer2} />
            <QuestionDropdown question={question4} answer={answer4} />
            <QuestionDropdown question={question6} answer={answer6} />
            <QuestionDropdown question={question8} answer={answer8} />
            <QuestionDropdown
              question={question10}
              answer={
                <div>
                  Feel free to reach out to us directly at&nbsp;
                  <Link href="mailto:hello@hackwestern.com">
                    hello@hackwestern.com
                  </Link>
                  &nbsp;and we will be more than happy to answer all of your
                  questions.
                </div>
              }
            />
          </QuestionColumnWrapper>
        </QuestionWrapper>
      </div>
    </motion.div>
  );
};

export default FAQ;
